import { useQuery } from '@tanstack/react-query';

import { useAuth } from '@/context/AuthContext';
import { authenticatedBitswanBackendInstance } from '@/lib/api-client';

export type AdvisorPractice = {
  organization_id: string;
  organization_name: string;
  profile_id: string;
  display_name: string;
  is_certified: boolean;
};

export function useAdvisorPractices() {
  const { isAuthenticated } = useAuth();

  const query = useQuery({
    queryKey: ['advisor-practices'],
    queryFn: async () => {
      const api = await authenticatedBitswanBackendInstance();
      const res = await api.get('/advisor/my-practices/');
      return (res.data?.practices ?? []) as AdvisorPractice[];
    },
    enabled: isAuthenticated,
    retry: false,
    staleTime: 5 * 60 * 1000,
  });

  return {
    practices: query.data ?? [],
    isAdvisor: (query.data ?? []).length > 0,
    isAnswered: query.isFetched || query.isError || !isAuthenticated,
  };
}
